import { useMutation } from "@apollo/client";
import ADD_REACTION from "queries/addReaction.gql";
import REMOVE_REACTION from "queries/removeReaction.gql";
import { GET_CAMPAIGN_UPDATE } from "queries/hooks";
const useReactions = (campaignUpdateId) => {
    var _a;
    const refetchUpdate = [{ query: GET_CAMPAIGN_UPDATE, variables: { id: campaignUpdateId } }];
    const [runAddReaction, { loading: addLoading, error: addError }] = useMutation(ADD_REACTION, {
        refetchQueries: refetchUpdate,
    });
    const [runRemoveReaction, { loading: removeLoading, error: removeError }] = useMutation(REMOVE_REACTION, { refetchQueries: refetchUpdate });
    const addReaction = (type) => {
        runAddReaction({
            variables: {
                input: {
                    id: campaignUpdateId,
                    model: "CampaignUpdate",
                    type,
                },
            },
        });
    };
    const removeReaction = () => {
        runRemoveReaction({
            variables: {
                input: {
                    id: campaignUpdateId,
                    model: "CampaignUpdate",
                },
            },
        });
    };
    return {
        addReaction,
        removeReaction,
        loading: addLoading || removeLoading,
        error: (_a = addError !== null && addError !== void 0 ? addError : removeError) !== null && _a !== void 0 ? _a : null,
    };
};
export default useReactions;
